import { FC } from 'react';
import { FilterList, FilterListItem } from 'react-admin';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';

const PlanFilter: FC = () => (
  <FilterList label="Plans" icon={<SubscriptionsIcon />}>
    <FilterListItem
      label="Monthly Old"
      value={{
        planFilter: 'monthlyOld',
      }}
    />
    <FilterListItem
      label="Monthly New"
      value={{
        planFilter: 'monthlyNew',
      }}
    />
    <FilterListItem
      label="Monthly Free Trial"
      value={{
        planFilter: 'monthlyFreeTrial',
      }}
    />
    <FilterListItem
      label="Yearly Old"
      value={{
        planFilter: 'yearlyOld',
      }}
    />
    <FilterListItem
      label="Yearly New"
      value={{
        planFilter: 'yearlyNew',
      }}
    />
    <FilterListItem
      label="Yearly Free Trial"
      value={{
        planFilter: 'yearlyFreeTrial',
      }}
    />
    <FilterListItem
      label="Life Time"
      value={{
        planFilter: 'lifeTime',
      }}
    />
  </FilterList>
);

export default PlanFilter;
